
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Meta } from '@storybook/addon-docs';
import tokens from '../compiled/tokens/js/tokens.js';
const _ = require('lodash');
const generateTokenTable = (props, filterLevel) => {
  const propsArray = Object.values(props);
  const hasComments = propsArray.some((p) => Boolean(p.comment));
  return (
    <table>
      <thead>
        <tr>
          <th style={{ width: '10%' }}>Name</th>
          <th>Value</th>
          {hasComments && <th>Comment</th>}
        </tr>
      </thead>
      <tbody>
        {propsArray.map((prop) => {
          let namespace = 'tokens';
          let name = `${prop.name}`;
          if (filterLevel === 'category') {
            namespace = _.kebabCase(prop.attributes.category);
            name = prop.name.slice(prop.attributes.category.length + 1);
          }
          if (filterLevel === 'type') {
            namespace = _.kebabCase(prop.attributes.type);
            name = prop.name.slice(
              prop.attributes.category.length + prop.attributes.type.length + 2
            );
          }
          return (
            <tr key={prop.name}>
              <td>
                <code>
                  {namespace}.${name}
                </code>
              </td>
              <td>
                <code>{prop.value}</code>
              </td>
              {hasComments && <td>{prop.comment}</td>}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};
const easeTable = generateTokenTable(tokens.ease, 'category');
const speedTable = generateTokenTable(tokens.time.transition, 'type');
const scaleTable = generateTokenTable(tokens.number.scale.effect, 'type');
const brightnessTable = generateTokenTable(
  tokens.number.brightness.control,
  'type'
);


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Design/Tokens/Motion" mdxType="Meta" />
    <h1>{`Motion`}</h1>
    <pre><code parentName="pre" {...{
        "className": "language-scss"
      }}>{`@use '../../compiled/tokens/scss/ease';
$example: ease.$in-out; // => cubic-bezier(0.455, 0.03, 0.515, 0.955)
`}</code></pre>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`import tokens from '../../compiled/tokens/js/tokens';
console.log(tokens.ease.in_out.value); // => "cubic-bezier(0.455, 0.03, 0.515, 0.955)"
`}</code></pre>
    <h2>{`Easing`}</h2>
    <>{easeTable}</>
    <h2>{`Speed`}</h2>
    <>{speedTable}</>
    <h2>{`Scale`}</h2>
    <>{scaleTable}</>
    <h2>{`Brightness`}</h2>
    <>{brightnessTable}</>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export const __page = () => { throw new Error("Docs-only story"); };

__page.parameters = { docsOnly: true };

const componentMeta = { title: 'Design/Tokens/Motion', includeStories: ["__page"],  };

const mdxStoryNameToKey = {};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;